import { createFeatureSelector } from '@ngrx/store';
import { PageState } from './page.state';

export const PAGE_NAME = 'page_work-order-detail';

export const pageState = createFeatureSelector<PageState>(PAGE_NAME);
